// components/ActionBar.jsx
import styles from '../styles/ActionBar.module.css';

const ActionBar = ({ count, onDelete, onPrint, onExport, onCategoryAssign, onArrival, onMove }) => {
  return (
    <div className={styles.actionBar}>
      <span className={styles.actionBar__count}>Выбрано позиций: {count}</span>
      <div className={styles.actionBar__buttons}>
        <button className={styles.redButton} onClick={onDelete}>Удалить выбранное</button>
        <button className={styles.blackButton} onClick={onArrival}>Приемка</button> 
        <button className={styles.blackButton} onClick={onPrint}>Распечатать штрихкод</button>
        <button className={styles.blackButton} onClick={onMove}>Перемещение</button>
        <button className={styles.grayButton} onClick={onExport}>Выполнить экспорт</button>
        <button className={styles.grayButton} onClick={onCategoryAssign}>Присвоить категорию</button>
      </div>
    </div>
  );
};

export default ActionBar;
